import { $ } from "@utils/select";
import { listen } from "@utils/bph";

export default function masonry(
  $el,
  config = {
    itemsSelector: null,
    columns: 2,
    breakpoint: "md",
  }
) {
  const { itemsSelector, columns, breakpoint } = config;

  if (!$el) return { destroy: () => {}, calcHeights: () => {} };

  const $$items = itemsSelector ? $(itemsSelector) : [...$el.children] || null;
  if (!$$items || $$items.length <= columns) {
    return { destroy: () => {}, calcHeights: () => {} };
  }

  const listener = listen(breakpoint, init);

  function init({ matches }) {
    if (matches) {
      calcHeights();
      window.addEventListener("resize", calcHeights);
      return;
    } else {
      destroy(true);
    }
  }

  function reset() {
    $$items.forEach((item) => item.removeAttribute("style"));
    $el.removeAttribute("style");
  }

  function calcHeights() {
    const trackHeights = {};
    reset();

    $$items.forEach((item) => {
      const thisIndex = $$items.indexOf(item);
      const thisColumn = thisIndex % columns;

      if (typeof trackHeights[thisColumn] == "undefined") {
        trackHeights[thisColumn] = 0;
      }

      trackHeights[thisColumn] +=
        item.getBoundingClientRect().height +
        parseFloat(getComputedStyle(item).marginBottom);

      // If the item has an item above it, then move it to fill the gap
      if (thisIndex - columns >= 0) {
        const getItemAbove = $$items[thisIndex - columns];
        const previousBottom = getItemAbove.getBoundingClientRect().bottom;
        const currentTop =
          item.getBoundingClientRect().top -
          parseFloat(getComputedStyle(item).marginBottom);

        item.style.top = `-${currentTop - previousBottom}px`;
      }
    });

    $el.style.setProperty(
      "height",
      `${Math.max(...Object.values(trackHeights))}px`
    );
  }

  function destroy(soft = false) {
    reset();
    window.removeEventListener("resize", calcHeights);
    if (!soft) listener.off();
  }

  return { destroy, calcHeights };
}
